import { render, staticRenderFns } from "./ForeignCessationTaskQueue.vue?vue&type=template&id=4b63dc9b&scoped=true&"
import script from "./ForeignCessationTaskQueue.vue?vue&type=script&lang=js&"
export * from "./ForeignCessationTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./ForeignCessationTaskQueue.vue?vue&type=style&index=0&id=4b63dc9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b63dc9b",
  null
  
)

export default component.exports